/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const orderPlanService = {
  getRecipientList: (params: any) =>
    request.get('/dc/charterer-entity', { params }),
  getList: (params: any) => request.get('/order-plans', { params }),

  getByPid: (pid: number | string) => request.get(`/order-plan/${pid}`),

  create: (data: {
    type: string;
    recipient_pid: number;
    charger_pid?: number;
  }) => request.post('/order-plan', data),

  update: (pid: number | string, data: any) =>
    request.put(`/order-plan/${pid}`, data),

  updateStatus: (pid: number | string, status: string | number) =>
    request.patch(`/order-plan/${pid}/status`, { status }),

  delete: (pid: number | string) => request.delete(`/order-plan/${pid}`)
};

export default orderPlanService;
